/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CategoryEnum {
    Uncategorized = 'UNCATEGORIZED',
    Purpose = 'PURPOSE',
    BondJames = 'BOND_JAMES',
    Invoices = 'INVOICES',
    TaxOffice = 'TAX_OFFICE',
    HardCollection = 'HARD_COLLECTION',
    InvestorLoan = 'INVESTOR_LOAN',
    InternalBorrowing = 'INTERNAL_BORROWING',
    SubleaseDeposit = 'SUBLEASE_DEPOSIT',
    InterestPaymentRefund = 'INTEREST_PAYMENT_REFUND',
    Yield = 'YIELD',
    MediationCommission = 'MEDIATION_COMMISSION',
    OperationPayments = 'OPERATION_PAYMENTS',
    TransferInternalAccounts = 'TRANSFER_INTERNAL_ACCOUNTS',
    InternalInstallment = 'INTERNAL_INSTALLMENT',
    Others = 'OTHERS'
}

export function CategoryEnumFromJSON(json: any): CategoryEnum {
    return CategoryEnumFromJSONTyped(json, false);
}

export function CategoryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryEnum {
    return json as CategoryEnum;
}

export function CategoryEnumToJSON(value?: CategoryEnum | null): any {
    return value as any;
}

